import React from 'react'
import { Button, Container, DialogContent, DialogTitle } from '@material-ui/core'
import { Dialog } from 'components/shared/Dialog'
import { Icon } from 'styles'

function RedirectFCDialog({ open, clientUrl, debtorUrl, onClose }) {
    const hasBothUrls = clientUrl && debtorUrl

    const message = hasBothUrls
        ? "There are two Businesses created for this Application on FactorCloud. Which one do you want to see?"
        : "A Business has been created for this Application on FactorCloud. Click below to view it."

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle>View Onboarded Business</DialogTitle>
            <DialogContent>
                <div className="text-center">
                    <Icon folder="icons" fileName="infoAlert.svg" />
                    <div className="mt-2 mb-4">{message}</div>
                </div>
                <Container className="redirect-fc-buttons">
                    {clientUrl && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => window.open(clientUrl, "_blank")}
                        >
                            Client on FactorCloud
                        </Button>
                    )}
                    {debtorUrl && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => window.open(debtorUrl, "_blank")}
                        >
                            Debtor on FactorCloud
                        </Button>
                    )}
                </Container>
            </DialogContent>
        </Dialog>
    )
}

export default RedirectFCDialog